export const iconFontAwesomeUsersPeoplePersonCane = (
	<i className="fa-solid fa-person-cane"></i>
);
